import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1),

    [theme.breakpoints.down("sm")]: {
      paddingInline: theme.spacing(2),
    },
  },

  title: {
    weight: 700,
    fontSize: 18,
  },

  action: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: theme.spacing(1),
    fontWeight: 500,
    color: theme.palette.primary.main,
    cursor: "pointer",
  },

  actionIcon: {
    "& svg": {
      width: 20,
      height: 20,
    },
  },
}));

export interface NutritionDrawerSectionTitleAction {
  name: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

export interface NutritionDrawerSectionTitleProps {
  title: string;
  action?: NutritionDrawerSectionTitleAction;
}

const NutritionDrawerSectionTitle: FC<NutritionDrawerSectionTitleProps> = (
  props,
) => {
  const { title, action } = props;
  const {
    name: actionName,
    onClick: actionOnClick,
    icon: actionIcon,
  } = action || {};

  const s = useStyles();

  return (
    <Box className={s.container}>
      <Typography variant="h4" className={s.title}>
        {title}
      </Typography>
      {action && (
        <Box className={s.action} onClick={actionOnClick}>
          <Typography>{actionName}</Typography>
          {actionIcon && <span className={s.actionIcon}>{actionIcon}</span>}
        </Box>
      )}
    </Box>
  );
};

export default NutritionDrawerSectionTitle;
